'use strict';
const mmWidgets = require('./mm-widgets');

mmWidgets.fn.inputFocusWidget = function () {
	return mmWidgets.each(this, function () {
		const widget = this;
		widget.on('click', function (e) {
			const fieldSelector = e.target.getAttribute('data-mm-input-focus'),
				selected = e.target.ownerDocument.querySelector(fieldSelector);
			if (selected) {
				selected.focus();
				selected.select();
			}
		});
	});
};
